export default {
  configurationActive: state =>
    state.configuredField !== null ||
    state.configuredTab !== null ||
    state.configuredCategory !== null ||
    state.configuredChapter !== null
};
